module.exports = __webpack_public_path__ + "assets/25d01ba6f2d2a8288cf47323bfaa65d9.svg";